import React from 'react';
import { useGLTF } from '@react-three/drei';

/**
 * The `RackWithEcab` component loads and renders a 3D GLTF model of a rack with an eCab.
 * It uses the `useGLTF` hook from @react-three/drei to load the model and its materials.
 * 
 * @param {object} props - Properties that can be applied to the group containing the model.
 * @param {number} [props.positionX=0] - Position on the X axis.
 * @param {number} [props.positionY=65.5] - Position on the Y axis. Default is 65.5.
 * @param {number} [props.positionZ=0] - Position on the Z axis.
 * @param {number} [props.rotationX=0] - Rotation around the X axis.
 * @param {number} [props.rotationY=0] - Rotation around the Y axis.
 * @param {number} [props.rotationZ=0] - Rotation around the Z axis.
 * @param {number} [props.scale=1] - Scale of the model.
 * 
 * @returns {JSX.Element} - A group containing the 3D model rendered with the loaded geometry and materials.
 */
export function RackWithEcab(props) {
  const { nodes } = useGLTF('/models/rackWithEcab-transformed.glb');

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes['Rack_nVent_Novastar_30U_-_600x800001'].geometry}
        material={nodes['Rack_nVent_Novastar_30U_-_600x800001'].material}
        position={[0, 65.5, 0]}
        scale={0.1}
      />
    </group>
  );
}

// Preloads the GLTF model to optimize performance by loading it in advance
useGLTF.preload('/models/rackWithEcab-transformed.glb');
